/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuShapeSquare4TiltIcon24Solid = forwardRef('UiMenuShapeSquare4TiltIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.55 5.086a2 2 0 0 0 0 2.828l3.536 3.536a2 2 0 0 0 2.828 0l3.536-3.536a2 2 0 0 0 0-2.828L18.914 1.55a2 2 0 0 0-2.828 0L12.55 5.086Z" }),
        React.createElement("path", { d: "M15 13a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-5Z" }),
        React.createElement("path", { d: "M2 15a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5Z" }),
        React.createElement("path", { d: "M4 2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Z" })));
});
